module.exports = __webpack_public_path__ + "media/images/malvinas/iso_ok2-3b3c041a353dc5a7a813aa632b1ebdd0.svg";